// extracted by mini-css-extract-plugin
export default {"root":"TemplateIdCell_root__mkiZB"};